import React, { useEffect, useState, useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';
import SharedProfile from '../../common/Profile/SharedProfile';
import { getCurrentUser } from '../../../services/authService';
import { formatPhoneForStorage } from '../../../utils/phoneUtils';
import { useTranslation } from 'react-i18next';

const CustomerProfile = () => {
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const loadUser = async () => {
      const data = await getCurrentUser();
      if (data?.user) {
        setUserData(data.user);
      }
    };
    loadUser();
  }, []);

  const handleSave = useCallback(async (formData) => {
    const payload = {
      username: formData.username,
      ...(formData.phone
        ? { phone: formatPhoneForStorage(formData.phone) }
        : {}),
      ...(formData.role
        ? { role_id: formData.role } // eslint-disable-line camelcase
        : {}),
    };

    await axiosInstance.put('/api/users/me', payload, {
      withCredentials: true,
    });

    const data = await getCurrentUser();
    if (data?.user) {
      setUserData(data.user);
    }
    window.dispatchEvent(new Event('profile-updated'));
  }, []);

  const handleVerifyPassword = useCallback(async (currentPassword) => {
    await axiosInstance.post(
      '/api/users/me/password/verify',
      { currentPassword },
      { withCredentials: true }
    );
  }, []);

  const handleChangePassword = useCallback(
    async (currentPassword, newPassword) => {
      await axiosInstance.post(
        '/api/users/me/password/change',
        { currentPassword, newPassword },
        { withCredentials: true }
      );
    },
    []
  );

  const personalFields = [
    {
      name: 'username',
      type: 'text',
      label: t('profileData.userName'),
      required: true,
      fullWidth: true,
    },
  ];

  const contactFields = [
    {
      name: 'email',
      type: 'email',
      label: t('Email'),
      required: true,
      fullWidth: true,
      disabled: true,
    },
    {
      name: 'phone',
      type: 'phoneWithCountry',
      label: t('profileData.phoneNumber'),
      required: true,
      fullWidth: true,
    },
  ];

  if (!userData) return null;

  return (
    <SharedProfile
      userData={userData}
      canEditProfile={true}
      showPasswordTab={true}
      showRolesTab={true}
      onSave={handleSave}
      onVerifyPassword={handleVerifyPassword}
      onChangePassword={handleChangePassword}
      personalFields={personalFields}
      contactFields={contactFields}
    />
  );
};

export default CustomerProfile;
